import { render, staticRenderFns } from "./ToolDieDetails.vue?vue&type=template&id=942b8d56&"
import script from "./ToolDieDetails.vue?vue&type=script&lang=js&"
export * from "./ToolDieDetails.vue?vue&type=script&lang=js&"
import style0 from "./ToolDieDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports